import { ModalContextConsumer } from "./ModalContext";
import { DnDModalInContext } from "./DnDModalInContext";

export const ModalRoot = () => (
  <ModalContextConsumer>
    {({ modalItems, hideModal, setConfirmOnCancel, setOnSave, updateModalPosition }) => {
      return modalItems
        .filter((modal) => modal.visible)
        .map((modal, idx) => {
          const hideModalWithUid = () => hideModal(modal.uid);
          const setConfirmOnCancelWithUid = setConfirmOnCancel(modal.uid);
          const setOnSaveWithUid = setOnSave(modal.uid);
          const updateModalPositionWithUid = updateModalPosition(modal.uid);
          return (
            <DnDModalInContext
              key={modal.uid}
              index={idx}
              modal={modal}
              hideModal={hideModalWithUid}
              updateModalPosition={updateModalPositionWithUid}
              setConfirmOnCancel={setConfirmOnCancelWithUid}
              setOnSave={setOnSaveWithUid}
            />
          );
        });
    }}
  </ModalContextConsumer>
);
